module.exports = __webpack_public_path__ + "static/img/18.33a4c760.jpg";